import styled from '@emotion/styled'

import { CONFIG } from '@/styles/emotion.config'

import Feature, { type ListFeatureProps } from './Feature'

export interface ListFeaturesProps {
  items: ListFeatureProps[]
}

const ListFeaturesStyles = styled.div({
  display: 'grid',
  gap: '1rem',
  [CONFIG.media.md]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
})

const ListFeatures = ({ items }: ListFeaturesProps) => (
  <ListFeaturesStyles>
    {items && items.map((item, index) => <Feature key={`lf_item_${index}`} {...item} />)}
  </ListFeaturesStyles>
)

export default ListFeatures
